// extracted by mini-css-extract-plugin
module.exports = {"PixPage":"PixPage_PixPage__8-HgF","container":"PixPage_container__g2Cph","closeButton":"PixPage_closeButton__3Um7_"};